module.exports = __webpack_public_path__ + "img/pan.98060174.png";